// src/townsquare/goal/types.ts
var TownsquareGoalAriResourceOwner = "townsquare", TownsquareGoalAriResourceType = "goal";

export {
  TownsquareGoalAriResourceOwner,
  TownsquareGoalAriResourceType
};
